import Companies from "../components/Pages/Companies.js";
export default Companies;

/*
import React from 'react';

function HomePage() {
  return (<div>
      <h1>Home</h1>
      <p>To see this demo in action, please try to login.</p>
    </div>);
}
export default HomePage;
*/
